(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let scheduled = false;

  const applyHeaderMode = () => {
    scheduled = false;
    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    const overflowList = header.querySelector('overflow-list');
    const hasReachedMinimum = overflowList?.hasAttribute('minimum-reached') === true;
    const desiredMode = !desktopQuery.matches || hasReachedMinimum ? 'drawer' : 'menu';

    if (header.dataset.menuStyle !== desiredMode) {
      header.dataset.menuStyle = desiredMode;
    }
  };

  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyHeaderMode);
  };

  const initialiseMobileDrawerFallback = () => {
    const details = document.querySelector('#Details-menu-drawer-container');
    if (!(details instanceof HTMLDetailsElement)) return;

    const summary = details.querySelector(':scope > summary');
    const drawer = details.querySelector(':scope > .menu-drawer');
    const backdrop = details.querySelector(':scope > .menu-drawer__backdrop');

    const syncDrawerState = () => {
      const isOpen = details.open;
      details.classList.toggle('menu-open', isOpen);
      document.documentElement.classList.toggle('ba-menu-open', isOpen);
      summary?.setAttribute('aria-expanded', String(isOpen));
      drawer?.setAttribute('aria-hidden', String(!isOpen));
    };

    details.addEventListener('toggle', syncDrawerState);

    drawer?.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
      button.addEventListener('click', () => {
        details.open = false;
        syncDrawerState();
      });
    });

    backdrop?.addEventListener('click', () => {
      details.open = false;
      syncDrawerState();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        syncDrawerState();
        if (summary instanceof HTMLElement) summary.focus();
      }
    });

    window.addEventListener('pageshow', syncDrawerState);
    syncDrawerState();
  };

  const initialise = () => {
    applyHeaderMode();
    initialiseMobileDrawerFallback();

    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    const observer = new MutationObserver(scheduleApply);
    observer.observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
      subtree: true,
    });

    desktopQuery.addEventListener?.('change', scheduleApply);
    window.addEventListener('resize', scheduleApply, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
